import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { userLoggedIn } from "../features/auth/authSlice";

export default function useAuthCheck() {
	const dispatch = useDispatch();
	const [authChecked, setAuthChecked] = useState(false);
	const [userRole, setUserRole] = useState("");

	useEffect(() => {
		const localStoredAuth = localStorage?.getItem("auth");

		if (localStoredAuth) {
			const auth = JSON.parse(localStoredAuth);
			if (auth?.accessToken && auth?.user) {
				setUserRole(auth.user.role);
				dispatch(
					userLoggedIn({
						accessToken: auth.accessToken,
						user: auth.user,
					})
				);
			}
		}

		setAuthChecked(true);
	}, [dispatch]);

    return { authChecked, userRole };
}
